import {
  UPDATECUSTOMERWALLETLIST_SUCCESS,
  UPDATECUSTOMERWALLETLIST_FAILED,
  RESET_UPDATECUSTOMERWALLETLIST,
  LOADING_UPDATECUSTOMERWALLETLIST,
  NETWORK_ERROR_UPDATECUSTOMERWALLETLIST,
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetUpdateCustomerWallet = () => {
  return { type: RESET_UPDATECUSTOMERWALLETLIST };
};

const updateCustomerWalletList =
  (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_UPDATECUSTOMERWALLETLIST });
    await partnerServices
      .post("updateCustomerWallet", userData, { headers: { AuthToken: authTokenIs } })
      .then((res) => {
        switch (res.data.status) {
          case "Success":
            dispatch(updateCustomerWalletsuccess(res.data));
            break;
          default:
            dispatch(updateCustomerWalletFailed(res.data));
            break;
        }
      })
      .catch((err) => {
        dispatch({
          type: NETWORK_ERROR_UPDATECUSTOMERWALLETLIST,
          payload: err,
        });
      });
  };
function updateCustomerWalletsuccess(data) {
  return {
    type: UPDATECUSTOMERWALLETLIST_SUCCESS,

    payload: data,
  };
}
function updateCustomerWalletFailed(data) {
  return {
    type: UPDATECUSTOMERWALLETLIST_FAILED,
    payload: data,
  };
}

export { resetUpdateCustomerWallet, updateCustomerWalletList };
